import { InsightsModel } from '@_types/organisms';
import { getModifiers } from '@helpers/functions';
import { SectionHeading } from '@molecules/section-heading/SectionHeading';
import RequireCss from '@helpers/RequireCss';
import RequireJs from '@helpers/RequireJs';
import { InsightView } from '@helpers/consts';

import InsightsFeatured from './InsightsFeatured';
import InsightsGrid from './InsightsGrid';

const Insights = (model: InsightsModel) => {
  const { carousel, sectionHeading, dataSet, excludeJs, excludeCss, view, carouselDesktop, readMore, gridModifier, extendsView, theviewOptions } =
    model;
  const styleModifiers = getModifiers(model, 'kf-o-insights');

  return (
    <div className={styleModifiers} {...dataSet} data-extends-view={extendsView} data-view={view}>
      <div className="kf-o-insights__inner">
        {sectionHeading ? (
          <SectionHeading {...sectionHeading}>
            {(view === InsightView.FEATURED ||
              view === InsightView.FEATURED_GRID ||
              view === InsightView.FEATURED_THE_VIEW ||
              view === InsightView.FEATURED_2 ||
              view === InsightView.FEATURED_2_GRID_3) && (
              <InsightsFeatured
                carouselDesktop={carouselDesktop}
                extendsView={extendsView}
                list={carousel}
                readMore={readMore}
                theviewOptions={theviewOptions}
                view={view}
              />
            )}

            {view === InsightView.GRID && <InsightsGrid carousel={carouselDesktop} list={carousel} readMore={readMore} />}
          </SectionHeading>
        ) : (
          <>
            {(view === InsightView.FEATURED ||
              view === InsightView.FEATURED_GRID ||
              view === InsightView.FEATURED_2 ||
              view === InsightView.FEATURED_2_GRID_3) && (
              <InsightsFeatured carouselDesktop={carouselDesktop} list={carousel} readMore={readMore} theviewOptions={theviewOptions} view={view} />
            )}

            {view === InsightView.GRID && (
              <InsightsGrid carousel={carouselDesktop} list={carousel} readMore={readMore} styleModifier={gridModifier} />
            )}
          </>
        )}
      </div>

      {!excludeCss && <RequireCss path={'b-insights'} />}
      {!excludeJs && <RequireJs defer path={'insights'} />}
    </div>
  );
};

export default Insights;
